import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  BellNotificationsProvider,
  GoogleApiLoaderContainer,
} from "@ryde/controls";
import { Layout } from "@ryde/layout";
import {
  InvestigationOverlayHost,
  ProfileScopeModalContainer,
} from "@ryde/pages";
import {
  appLanguageSelector,
  companyIdSelector,
  profileDtoAtom,
  systemSettingsDtoAtom,
} from "@ryde/shared";

export const AppServicesProvider: FC = () => {
  const profile = useRecoilValue(profileDtoAtom);
  const appLanguage = useRecoilValue(appLanguageSelector);
  const systemSettings = useRecoilValue(systemSettingsDtoAtom);
  const currentCompanyId = useRecoilValue(companyIdSelector);
  const userDataLoaded = useMemo(() => {
    return (
      Boolean(profile) && Boolean(systemSettings) && Boolean(currentCompanyId)
    );
  }, [currentCompanyId, profile, systemSettings]);

  return (
    <>
      {userDataLoaded && <GoogleApiLoaderContainer language={appLanguage} />}
      {userDataLoaded && <Layout />}
      <ProfileScopeModalContainer />
      {/* Self-gating: renders nothing until a ride is put under investigation, from any entry point. */}
      <InvestigationOverlayHost />
      {userDataLoaded && <BellNotificationsProvider />}
    </>
  );
};
